import { isHttpClientError } from 'core/infra/http/HttpClient'

export const TOKEN_EXPIRED_DETAIL = 'token expired'

export function isTokenExpiredError(error: unknown): boolean {
  if (!isHttpClientError(error)) {
    return false
  }

  const data = error.response?.data as { detail?: string } | undefined

  return data?.detail === TOKEN_EXPIRED_DETAIL
}
